import { deserialize } from 'cerialize'
import { FunctionAliasModel } from 'Pages/pp/matrixRole'
import { RoleInterfaceElementModel } from 'Models'
import { Roles } from 'Constants/Roles'

export class RoleModel {
	@deserialize public id: number
	@deserialize public slug: Roles
	@deserialize public name: string
	@deserialize public functions?: FunctionAliasModel[]
	@deserialize public interface_elements?: RoleInterfaceElementModel[]
}
